import { useFormContext } from 'react-hook-form';

import { CustomFormElement } from '@/components/common';
import { planBuilderConstants } from '@/modules/AdminTools/lib/constants';
import { useSelector } from 'react-redux';

const { NAME, NAME_LABEL } = planBuilderConstants;

const Name = () => {
  const { register } = useFormContext();

  const planErrors = useSelector((state) => state?.errors?.errors?.updatePlan);

  const nameError = planErrors?.[NAME];

  return (
    <CustomFormElement
      register={register}
      type="text"
      id={NAME}
      name={NAME}
      label={NAME_LABEL}
      error={nameError}
      required
    />
  );
};

export default Name;
